//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// @ is an alias to /src
import { mapState } from 'vuex'
import { Indicator, Toast } from 'mint-ui';
export default {
  name: 'upload-photo-page',
  data() {
    return {
      images: [],
      key: '',
      popupVisible: false,
      keys: [
        {
          key: 'image_vision',
          text: '含視力結果的病歷'
        }, {
          key: 'image_mydriatic',
          text: '散瞳驗光結果'
        }, {
          key: 'image_biometric',
          text: '生物測量結果'
        },
        {
          key: 'intraocular_pressure',
          text: '眼壓'
        },
        {
          key: 'color_fundus',
          text: '眼底彩照'
        }
      ],
      imageBody: {
        image_vision: [],
        image_mydriatic: [],
        image_biometric: [],
        intraocular_pressure: [],
        color_fundus: []
      },
      localData: '',
      uploaded: false
    }
  },
  computed: mapState({
    user: state => state.user.user
  }),
  mounted: function () {
  },
  methods: {
    showImage (key) {
      this.key = key
      this.popupVisible = true
    },
    goBack () {
      this.$router.push({
        path: '/'
      })
    },
    uploadImage () {
      let flag = false
      this.keys.forEach((item) => {
        if (flag) {
          return false
        }
        if (!this.imageBody[item.key].length) {
          flag = true
          return Toast({
            message: `請上傳${item.text}`,
            duration: 3000
          })
        }
      })
      if (flag) {
        return false
      }
      Indicator.open({
        text: '正在上傳...',
        spinnerType: 'fading-circle'
      })
      this.$store.httpDispatch({})('uploadImage', this.imageBody).then(() => {
        Indicator.close()
        this.uploaded = true
      }).catch((err) => {
        Indicator.close()
        console.log(err)
        Toast({
          message: '請求失敗',
          duration: 3000
        })
      })
    },
    // wx upload image
    chooseImage (key) {
      const that = this
      if (that.imageBody[key].length >= 5) {
        return Toast({
          message: '每種報告最多只能選擇5張照片',
          duration: 3000
        })
      }
      wx.chooseImage({
        count: 5, // 默認9
        sizeType: ['original', 'compressed'], // 可以指定是原圖還是壓縮圖，默認二者都有
        sourceType: ['album', 'camera'], // 可以指定來源是相冊還是相機，默認二者都有
        success: function (res) {
          that.imageBody[key] = []
          var localIds = res.localIds; // 返回選定照片的本地ID列表，localId可以作為img標簽的src屬性顯示圖片
          let length = localIds.length
          let i = 0
          const upload = () => {
            if (i >= length) {
              return
            }
            let image = {}
            image.localId = localIds[i]
            wx.uploadImage({
              localId: image.localId, // 圖片的localID
              isShowProgressTips: 1, // 默認為1，顯示進度提示
              success: function (res) {
                var serverId = res.serverId; // 返回圖片的服務器端ID
                image.serverId = serverId
                that.imageBody[key].push(image)
                i++
                upload()
              }
            })
          }
          upload()
        }
      })
    }
  }
}
